import { gql } from '@edreamsodigeo/frontend-api-client';

export const GET_ACCOMMODATION_RECOMMENDATIONS_BY_IATA_CODE = gql`
  query getAccommodationRecommendationsByIataCode(
    $accommodationRecommendationByIataCodeRequest: AccommodationRecommendationByIataCodeRequest!
  ) {
    getAccommodationRecommendationsByIataCode(
      accommodationRecommendationByIataCodeRequest: $accommodationRecommendationByIataCodeRequest
    ) {
      propertyMappingIds {
        id
      }
    }
  }
`;
